import {
  merge, filter, propEq, not,
  lensPath, over, compose
} from 'ramda';

import {
  LOAD_WCC_MOT_FAIL,
  LOAD_WCC_MOT_REQUEST,
  LOAD_WCC_MOT_SUCCESS,
  LOAD_WCC_MOT_DATA_FAIL,
  LOAD_WCC_MOT_DATA_REQUEST,
  LOAD_WCC_MOT_DATA_SUCCESS,
  POST_WCC_MOT_FAIL, POST_WCC_MOT_REQUEST, POST_WCC_MOT_SUCCESS,
  PUT_WCC_MOT_FAIL, PUT_WCC_MOT_REQUEST, PUT_WCC_MOT_SUCCESS,
  LOAD_MANUFACTURING_ORDER_TYPES_FAIL,
  LOAD_MANUFACTURING_ORDER_TYPES_SUCCESS,
  LOAD_MANUFACTURING_ORDER_TYPES_REQUEST,
  CLEAR_WCC_MOT_DATA,
  DELETE_WCC_MOT_SUCCESS
} from 'src/store/actions/wccMotActions';

const initialState = {
  wcc: [],
  rowData: [],
  manufactTypes: [],
  fetching: false,
  errors: []
};

const addNewRow = (row, state) => [row, ...state.rowData];

const wccMotReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_WCC_MOT_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_WCC_MOT_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case LOAD_WCC_MOT_SUCCESS:
      return merge(state, {
        wcc: action.payload,
        fetching: false,
        errors: []
      });
    case LOAD_WCC_MOT_DATA_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_WCC_MOT_DATA_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case LOAD_WCC_MOT_DATA_SUCCESS:
      return merge(state, {
        rowData: action.payload,
        fetching: false,
        errors: []
      });
    case LOAD_MANUFACTURING_ORDER_TYPES_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_MANUFACTURING_ORDER_TYPES_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case LOAD_MANUFACTURING_ORDER_TYPES_SUCCESS:
      return merge(state, {
        manufactTypes: action.payload,
        fetching: false,
        errors: []
      });
    case POST_WCC_MOT_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case POST_WCC_MOT_REQUEST:
      return merge(state, { fetching: true });
    case POST_WCC_MOT_SUCCESS:
      return merge(state, { rowData: addNewRow(action.payload, state) });
    case PUT_WCC_MOT_FAIL:
      return merge(state, {
        fetching: false,
        errors: [action.error]
      });
    case PUT_WCC_MOT_SUCCESS:
      return merge(state, {
        fetching: false,
        errors: []
      });
    case PUT_WCC_MOT_REQUEST:
      return merge(state, { fetching: true });
    case CLEAR_WCC_MOT_DATA:
      return merge(state, initialState);
    case DELETE_WCC_MOT_SUCCESS: {
      const { payload: id } = action;
      const listL = lensPath(['rowData']);

      const withoutRemoved = filter(compose(
        not,
        propEq('Id', id)
      ));

      return over(listL, withoutRemoved, state);
    }
    default:
      return state;
  }
};

export default wccMotReducer;
